import { ReactElement } from 'react';
import { SingleValueChart } from './single-value-chart';
import { useAnalyticsTranslation } from '../hooks';
import { useTasksAndAlertsAnalytics } from '../providers/tasks-and-alerts-analytics-provider';

export function TotalTasksChart(): ReactElement {
    const { t } = useAnalyticsTranslation();
    const { totalTasksData, status } = useTasksAndAlertsAnalytics();

    return (
        <SingleValueChart
            title={t('components.total_tasks_chart.title')}
            description={t('components.total_tasks_chart.description')}
            value={totalTasksData?.value}
            dateString={totalTasksData?.dateString}
            loading={status === 'pending'}
            error={status === 'error'}
        />
    );
}
